import client from "../Client/HttpClient";

const ApiPath = "AcademicTeacherAssigment";


export default {
  GetTeacherAssignments: (): Promise<any[]> => client.get(`${ApiPath}`),
  GetTeacherAssignmentById: (Id: any): Promise<any> =>client.get(`${ApiPath}/${Id}`),
  PostTeacherAssignment: (data: any): Promise<any> => client.post(`${ApiPath}`, data),
};
